import { Logger } from '@frontend/Logger';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

import { addWorkflowStep, removeWorkflowStep, updateWorkflowStep } from '../redux/workflow-step-slice';
import { WorkflowStep } from '../workflow-step';

enum MessageTypes {
    UPDATED = 'workflow_step_updated',
    DELETED = 'workflow_step_deleted',
    CREATED = 'workflow_step_created'
}

export class WorkflowStepEventHandler {
    #dispatch: ThunkDispatch<any, any, AnyAction>;

    constructor(dispatch: ThunkDispatch<any, any, AnyAction>) {
        this.#dispatch = dispatch;
    }
    public onMessageEvent(event: MessageEvent<string>): void {
        const payload = JSON.parse(event.data) as { message: MessageTypes; data: WorkflowStep; changes?: any };
        switch (payload.message) {
            case MessageTypes.UPDATED:
                this.onUpdate(payload);
                break;
            case MessageTypes.DELETED:
                this.onDelete(payload);
                break;
            case MessageTypes.CREATED:
                this.onCreate(payload);
                break;
        }
    }

    private onUpdate(payload: { message: MessageTypes; data: WorkflowStep; changes?: any }) {
        Logger.log('Updating workflow step in store', {}, payload.data);
        this.#dispatch(updateWorkflowStep(payload.data));
    }

    private onDelete(payload: { message: MessageTypes; data: WorkflowStep }) {
        Logger.log('Removing workflow step from store', {}, payload.data);
        this.#dispatch(removeWorkflowStep(payload.data.id));
    }

    private onCreate(payload: { message: MessageTypes; data: WorkflowStep; changes?: any }) {
        Logger.log('Adding workflow step to store', {}, payload.data);
        this.#dispatch(addWorkflowStep(payload.data));
    }
}
